import { useStore } from "vuex";
import { computed, ComputedRef } from "vue";

interface IFeatureFlag {
  isFeatureFlagSet: (featureFlag: string, defaultReturn?: boolean) => boolean;
  computedFeatureFlag: (
    featureFlag: string,
    defaultReturn?: boolean
  ) => ComputedRef<boolean>;
}
const useFeatureFlag = (): IFeatureFlag => {
  const store = useStore();
  const featureFlags = computed(() => {
    return store.state.merchant?.featureFlags;
  });
  // the function is meant to check if there are feature flags available
  // that the specific featureFlag is set and, in that case, return its value.
  // The second parameter, `defaultReturn` is set to be able to control the
  // result if the flag is not set yet coming from the back end.
  // This way we can release code in both front end and backend without sync
  const isFeatureFlagSet = (
    featureFlag: string,
    defaultReturn = false
  ): boolean => {
    if (
      featureFlags.value &&
      typeof featureFlags.value[featureFlag] !== "undefined"
    ) {
      return featureFlags.value[featureFlag];
    }
    return defaultReturn;
  };
  // This function is meant to be used in computed properties to reactively
  const computedFeatureFlag = (
    featureFlag: string,
    defaultReturn = false
  ): ComputedRef<boolean> => {
    return computed((): boolean => {
      if (
        featureFlags.value &&
        typeof featureFlags.value[featureFlag] !== "undefined"
      ) {
        return featureFlags.value[featureFlag];
      }
      return defaultReturn;
    });
  };
  return {
    isFeatureFlagSet,
    computedFeatureFlag,
  };
};

export default useFeatureFlag;
